import React, {useEffect, useRef, useState} from "react";
import {showToastCustom} from "../../../components/toast/customToast";
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from "reactstrap";
import {
    ButtonCancel,
    ButtonEdit,
    ButtonNew,
    ButtonSubmit,
    GenericTableButton
} from "../../../components/buttons/buttonsActions";
import Select from "react-select";
import {employeeService} from "../../../jwt/_services/hr/employeeService";
import {userProvider} from "../../../providers/userProvider";
import {departmentProvider} from "../../../providers/departmentProvider";
import {
    error,
    FORM,
    info,
    infoMsg,
    MAX_NAME,
    REQUIRED,
    saveMsg,
    success,
    updateMsg
} from "../../../components/i18n/i18n";
import * as Yup from "yup";
import {ErrorMessage, useForm} from "react-hook-form";
import {showLoader} from "../../../components/loader/loader";
import {MAX_NAME_SIZE} from "../../../components/menu-flower/constants";
import {TT_HISTORY} from "../../../components/i18n/toolTips";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";

export default function EmployeeForm(props) {

    const [editMode, setEditMode] = useState(!!props?.item?.id);
    const [disableInputs, setDisableInputs] = useState(false);
    const [saveSuccess, setSaveSuccess] = useState(false);
    const [savedData, setSavedData] = useState(editMode ? props.item : null);
    const [departmentsOptions, setDepartmentsOptions] = useState([]);
    const [departments, setDepartments] = useState(editMode ? props.item?.departments : null);
    const [userOptions, setUserOptions] = useState([]);
    const [user, setUser] = useState(editMode ? props.item?.user : []);
    const [loading, setLoading] = useState(false);

    const [showModal, setShowModal] = useState(true)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(savedData);
    }

    useEffect(() => {
        setLoading(true);
        userProvider.getAllUserWithoutEmployee()
            .then(result => {
                if (result) {
                    let userOptions = result;
                    if (props.item?.user) {
                        setLoading(false);
                        const index = userOptions.findIndex(n => n.id === user.id);
                        setUser(userOptions[index]);
                    } else {
                        setLoading(false);
                    }
                    setUserOptions(result);
                }
                setLoading(false);

            })
            .catch(_ => {
                setLoading(false);
            });

        setLoading(true);
        departmentProvider.getOptions()
            .then(result => {
                if (result) {
                    let departmentOptions = result;
                    let depArray = []
                    if (departments) {
                        departments.forEach((ep) => {
                            const index = departmentOptions.findIndex(n => n.id === ep.id);
                            depArray.push(departmentOptions[index]);
                        });
                    }
                    setDepartments(depArray);
                    setDepartmentsOptions(departmentOptions);
                }
                setLoading(false);
            })
            .catch(_ => {
                setLoading(false);
            })

    }, []);

    const validationSchema = Yup.object().shape({
        name: Yup.string().required(REQUIRED).max(MAX_NAME_SIZE, MAX_NAME),
        lastName: Yup.string().required(REQUIRED).max(MAX_NAME_SIZE, MAX_NAME),
        number: Yup.string().required(REQUIRED)
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            name: savedData?.name,
            lastName: savedData?.lastName,
            number: savedData?.number,
        }
    });

    const changeUser = (value) => {
        setUser(value);
    }

    const changeDepartments = (value) => {
        let depto = [];
        depto.push(value);
        setDepartments(depto);
    }

    const onSubmit = (data, _) => {
        setLoading(true);
        const dataRequest = {
            id: data.id,
            name: data.name,
            lastName: data.lastName,
            number: data.number,
            user: user,
            departments: departments
        };
        if (!editMode) {
            //Save
            return employeeService.saveItem(dataRequest)
                .then(resultData => {
                    setResult(resultData);
                    showToastCustom(success, saveMsg);
                })
                .catch(errorMessage => {
                    setLoading(false);
                    showToastCustom(error, errorMessage);
                });
        } else {
            //Update
            let id = savedData.id;
            delete savedData.id;
            if (JSON.stringify(savedData) === JSON.stringify(dataRequest)) {
                return showToastCustom(info, infoMsg);
            }

            return employeeService.updateItem(id, dataRequest)
                .then(resultData => {
                    setResult(resultData);
                    showToastCustom(success, updateMsg);
                })
                .catch(errorMessage => {
                    setLoading(false);
                    showToastCustom(error, errorMessage);
                });
        }
    };

    const setResult = (resultData) => {
        setLoading(false);
        setSavedData(resultData);
        setDisableInputs(true);
        setSaveSuccess(true);
        setEditMode(true)
    }

    const resetForm = () => {
        setUser('');
        setDepartments('')
        setSavedData(null);
        setEditMode(false);
        setDisableInputs(false);
        setSaveSuccess(false);
        reset();
    }

    const beginEdit = () => {
        setEditMode(true);
        setSaveSuccess(false)
        setDisableInputs(false);
    }

    return (
        <Card>
            {loading ? showLoader() : null}
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-edit mr-2"/>{FORM}
                {
                    editMode && <div className="float-right">
                        <GenericTableButton
                            toolTip={TT_HISTORY}
                            icon={'fa-clock'}
                            permission={'search'}
                            onClick={showHistory}
                        />
                    </div>
                }
            </CardTitle>
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md="12">
                            <FormGroup>
                                <Label htmlFor="id">ID</Label>
                                <Input type="id" name="id" id="id"
                                       disabled
                                       value={editMode ? savedData?.id : ''}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="4">
                            <FormGroup>
                                <Label>Nombre</Label>
                                <Input type="name" name="name"
                                       placeholder="Ingrese nombre"
                                       innerRef={register}
                                       disabled={disableInputs}
                                       className={(errors.name ? ' is-invalid' : '')}
                                />
                                <ErrorMessage errors={errors} name="name" component="div" className="invalid-feedback"/>
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label>Apellido</Label>
                                <Input type="name" name="lastName"
                                       placeholder="Ingrese Apellido"
                                       innerRef={register}
                                       disabled={disableInputs}
                                       className={(errors.lastName ? ' is-invalid' : '')}
                                />
                                <ErrorMessage errors={errors} name="lastName" component="div"
                                              className="invalid-feedback"/>
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label>Número</Label>
                                <Input type="number" name="number"
                                       placeholder="Ingrese número"
                                       innerRef={register}
                                       disabled={disableInputs}
                                       className={(errors.number ? ' is-invalid' : '')}
                                />
                                <ErrorMessage errors={errors} name="number" component="div"
                                              className="invalid-feedback"/>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label>Usuario</Label>
                                <Select
                                    value={user}
                                    options={userOptions}
                                    placeholder="Selecciona una opción"
                                    isDisabled={disableInputs}
                                    isSearchable={true}
                                    isClearable={true}
                                    ref={register}
                                    onChange={changeUser}/>
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label>Departamento</Label>
                                <Select
                                    value={departments}
                                    options={departmentsOptions}
                                    placeholder="Selecciona una opción"
                                    isDisabled={disableInputs}
                                    isSearchable={true}
                                    isClearable={true}
                                    ref={register}
                                    onChange={changeDepartments}/>
                            </FormGroup>
                        </Col>
                    </Row>
                    <CardBody className="border-top">
                        {
                            saveSuccess ?
                                <div className="float-right">
                                    <ButtonNew onClick={() => {
                                        resetForm()
                                    }}/>
                                    <ButtonEdit onClick={() => {
                                        beginEdit()
                                    }}/>
                                    <ButtonCancel onClick={props.toggleParent}/>
                                </div>
                                : <div className="float-right">
                                    <ButtonSubmit/>
                                    <ButtonCancel onClick={props.toggleParent}/>
                                </div>
                        }
                    </CardBody>
                </Form>
            </CardBody>
            {
                showModal && <LogHistoryModal
                    ref={ modalRef }
                    item={ savedData }
                />
            }
        </Card>
    )
}